export const BasicPlans = [
    {
        title: 'Job Automator',
        type: 'Basic',
        duration: [
            {
                discount: '50%',
                timeframe: 'Per Use',
                price: '4 USD'
            },
            {
                discount: '75%',
                timeframe: 'Per Week',
                price: '16 USD'
            },
            {
                discount: '100%',
                timeframe: 'Per Month',
                price: '48 USD'
            }
        ]
    },
    {
        title: 'Exam Simulator',
        plan: 'basic',
        duration: [
            {
                discount: 'once',
                timeframe: 'Per Use',
                price: '**** USD'
            },
            {
                discount: 'week',
                timeframe: 'Per Week',
                price: '**** USD'
            },
            {
                discount: 'month',
                timeframe: 'Per Month',
                price: '**** USD'
            }
        ]
    },

]

export const PremiumPlans =[{
    title: 'Premium (Everything)',
    plan: 'premium',
    duration: [
        {
            timeframe: 'Per use',
            price: 5
        },
        {
            timeframe: 'Per week',
            price: 20
        },
        {
            timeframe: 'Per year',
            price: 150
        }
    ],
    offers:[
        {
            package: 'Job Automator',
            discount: '100%'
        },
        {
            package: 'Exam Simulator',
            discount: '100%'
        }
    ],
    message: 'Get a 100% of all our product and service for a discounted fee!!'
}]


// Backend applies regional multipliers; client just displays provided prices.

export const examSimulatorPricing = ( pricePerWeekStudent, pricePerMonthPro, currency) => {
    return [
        {
            duration: "Pro Plan",
            discount: 60,
            price: pricePerMonthPro,
            currency: currency,
            popular: true,
            offer: true,
            features: [
                { title: "duration", available: true, text: "Duration: 1 Month" },
                { title: "unlimitedExams", available: true, text: "15 Exams Per Month" },
                { title: "unlimitedGrading", available: true, text: "15 Detailed Gradings" },
                { title: "studyPlan", available: true, text: "AI Study Plans" },
                { title: "aiTutor", available: true, text: "24/7 AI Tutor Access" },
                { title: "examInsights", available: true, text: "Deep Performance Insights" },
                { title: "peerBenchmarking", available: true, text: "Peer Benchmarking" },
                { title: "uploadLimit", available: true, text: "Upload up to 5 docs (50MB limit each)" },
                { title: "customMaterial", available: true, text: "Custom Study Material Exams" },
                { title: "allFreePlans", available: true, text: "+ All Premium Features" },
            ]
        },
        {
            duration: "Student Plan",
            discount: 50,
            price: pricePerWeekStudent,
            currency: currency,
            popular: false,
            offer: true,
            features: [
                { title: "duration", available: true, text: "Duration: 1 Week" },
                { title: "unlimitedExams", available: true, text: "3 Exams Per Week" },
                { title: "unlimitedGrading", available: true, text: "3 Detailed Gradings" },
                { title: "studyPlan", available: true, text: "AI Study Plans" },
                { title: "aiTutor", available: true, text: "24/7 AI Tutor Access" },
                { title: "uploadLimit", available: true, text: "Upload up to 10 docs (5MB limit each)" },
                { title: "examInsights", available: true, text: "Limited Performance Insights" },
                { title: "customMaterial", available: true, text: "Custom Study Material Exams" },
                { title: "allFreePlans", available: true, text: "+ All Student Features" },
            ]
        },
        {
            duration: "Free Plan",
            discount: 0,
            price: 0,
            currency: currency,
            popular: false,
            offer: false,
            features: [
                { title: "unlimitedExams", available: true, text: "1 Exam Per Month" },
                { title: "unlimitedGrading", available: true, text: "1 Detailed Grading" },
                { title: "studyPlan", available: false, text: "No Study Plans" },
                { title: "aiTutor", available: false, text: "1 AI Tutor Access" },
                { title: "uploadLimit", available: true, text: "Upload 1 doc (2MB limit)" },
                { title: "examInsights", available: false, text: "Performance Insights" },
            ]
        }
    ]
}

export const premiumPricing = (pricePerUse, pricePerWeek, pricePerYear, currency) => {
    return [
        {
            duration: "Per Year",
            discount: 80,
            price: pricePerYear,
            currency: currency,
            popular: true,
            offer: true,
            features: [
                { title: "allProducts", available: true, text: "100% Access to All Products" },
                { title: "jobAutomator", available: true, text: "Full Job Automator (Pro)" },
                { title: "examSimulator", available: true, text: "Full Exam Simulator (Pro)" },
                { title: "autoApply", available: true, text: "Unlimited Auto-Applies" },
                { title: "aiTutor", available: true, text: "Personal AI Mentor" },
                { title: "premiumSupport", available: true, text: "Priority Human Support" }
            ]
        },
        {
            duration: "Per Week",
            discount: 50,
            price: pricePerWeek,
            currency: currency,
            popular: false,
            offer: true,
            features: [
                { title: "allProducts", available: true, text: "100% Access to All Products" },
                { title: "jobAutomator", available: true, text: "Full Job Automator (Pro)" },
                { title: "examSimulator", available: true, text: "Full Exam Simulator (Pro)" },
                { title: "autoApply", available: true, text: "50 Auto-Applies/Week" },
                { title: "aiTutor", available: true, text: "Personal AI Mentor" }
            ]
        },
        {
            duration: "Per Use",
            discount: 20,
            price: pricePerUse,
            currency: currency,
            popular: false,
            offer: false,
            features: [
                { title: "allProducts", available: true, text: "One-time Access (All products)" },
                { title: "jobAutomator", available: true, text: "Job Automator (Single)" },
                { title: "examSimulator", available: true, text: "Exam Simulator (Single)" }
            ]
        }
    ]
}

export const jobAutomatorPricing = (pricePerUse, pricePerWeek, pricePerMonth, currency) => {
    // Pass-through prices from backend without any client-side adjustments

    return [
        {
            duration: "Per Month",
            discount: 50,
            price: pricePerMonth,
            currency: currency,
            popular: true,
            offer: true,
            features: [
                { title: "duration", available: true, text: "Duration: 1 Month" },
                { title: "recommendation", available: true, text: "I want a Job in less than 2 Months" },
                { title: "autoApply", available: true, text: "Apply For Me (300 Apply)" },
                { title: "scheduleAutoApply", available: true, text: "Schedule Apply For Me" },
                { title: "interviewGuarantee", available: true, text: "Guaranteed Interviews" },
                { title: "reAccessSaved", available: true, text: "Resume Storage for Later Access" },
                { title: "createSeveral", available: true, text: "Unlimited CV creation" },
                { title: "coverLetter", available: true, text: "Tailored Cover Letters" },
                { title: "insiderConnections", available: true, text: "Insider Connections" },
                { title: "jobMatchInsights", available: true, text: "Job Match Insight" },
                { title: "deepCompanyInsights", available: true, text: "Deep Company Insights" },
                { title: "editPreview", available: true, text: "Edit Ai Generated CV" },
                { title: "sharableLink", available: true, text: "Sharable Link to Resume" },
                { title: "changeName", available: true, text: "Change CV Name" },
                { title: "downloadablePDF", available: true, text: "Download Resume as PDF" },
                { title: "severalTemplates", available: true, text: "Choose Your Template" },
                { title: "aiJobSuggestions", available: true, text: "900+ Job Connections" },
                { title: "careerCoach", available: true, text: "24/7 Human Career Coach" },
                { title: "interviewMockQuota", available: true, text: "Interview mock: Unlimited" },
                { title: "followUpEmailQuota", available: true, text: "Follow-up email: Unlimited" },
                { title: "aiInsights", available: true, text: "Ai Career Insights" },
                { title: "courses", available: true, text: "Ai‑Curated Courses" },
                { title: "recruiterAccess", available: true, text: "Recruiter LinkedIn Access" },
                { title: "allFreePlans", available: true, text: "+ Other Available Features" },
            ]
        },
        {
            duration: "Per Week",
            discount: 40,
            price: pricePerWeek,
            currency: currency,
            popular: false,
            offer: true,
            features: [
                // Per Month additional features (added as unavailable here)
                { title: "duration", available: true, text: "Duration: 1 Week" },
                { title: "interviewGuarantee", available: false, text: "Guaranteed Interviews" },
                { title: "insiderConnections", available: false, text: "Insider Connections" },
                { title: "sharableLink", available: false, text: "Sharable Link to Resume" },
                { title: "changeName", available: false, text: "Change CV Name" },
                { title: "careerCoach", available: false, text: "24/7 Human Career Coach" },
                { title: "recruiterAccess", available: false, text: "Recruiter LinkedIn Access" },
                { title: "autoApply", available: true, text: "Apply For Me (50 Apply)" },
                { title: "scheduleAutoApply", available: false, text: "Schedule Apply For Me" },
                { title: "recommendation", available: true, text: "90%+ Interview Chance Connects" },
                { title: "reAccessSaved", available: true, text: "Resume Storage for Later Access" },
                { title: "createSeveral", available: true, text: "Unlimited CV creation" },
                { title: "coverLetter", available: true, text: "Tailored Cover Letters" },
                { title: "editPreview", available: true, text: "Edit Ai Generated CV" },
                { title: "downloadablePDF", available: true, text: "Download Resume as PDF" },
                { title: "severalTemplates", available: true, text: "Choose Your Template" },
                { title: "aiJobSuggestions", available: true, text: "50+ Job Connections" },
                { title: "interviewMockQuota", available: true, text: "Interview mock: Unlimited" },
                { title: "followUpEmailQuota", available: true, text: "Follow-up email: Unlimited" },
                { title: "aiInsights", available: true, text: "Ai Career Insights" },
                { title: "courses", available: true, text: "Ai‑Curated Courses" },
                { title: "allFreePlans", available: true, text: "+ All Free Plan Features" },
            ]
        },
        {
            duration: "Per Use",
            discount: 30,
            price: pricePerUse,
            currency: currency,
            popular: false,
            offer: false,
            features: [
                // Per Month additional features (added as unavailable here)
                { title: "duration", available: true, text: "Duration: 1 Resume, 1 Day" },
                { title: "reAccessSaved", available: false, text: "Resume Storage for Later Access" },
                { title: "createSeveral", available: false, text: "Unlimited CV creation" },
                { title: "insiderConnections", available: false, text: "Insider Connections" },
                { title: "jobMatchInsights", available: false, text: "Job Match Insight" },
                { title: "deepCompanyInsights", available: false, text: "Deep Company Insights" },
                { title: "sharableLink", available: false, text: "Sharable Link to Resume" },
                { title: "severalTemplates", available: false, text: "Choose Your Template" },
                { title: "careerCoach", available: false, text: "24/7 Human Career Coach" },
                { title: "recruiterAccess", available: false, text: "Recruiter LinkedIn Access" },
                { title: "recommendation", available: true, text: "(One-time Resume)" },
                { title: "coverLetter", available: true, text: "1 cover letter/day" },
                { title: "editPreview", available: true, text: "Edit Ai Generated CV" },
                { title: "changeName", available: true, text: "Change CV Name" },
                { title: "downloadablePDF", available: true, text: "Download Resume as PDF" },
                { title: "aiJobSuggestions", available: true, text: "Job Connections (maybe)" },
                { title: "autoApply", available: true, text: "Apply For Me 5/mo" },
                { title: "scheduleAutoApply", available: false, text: "Schedule Apply For Me" },
                { title: "interviewMockQuota", available: true, text: "Interview mock: 1/day" },
                { title: "followUpEmailQuota", available: true, text: "Follow-up email: 1/day" },
                { title: "aiInsights", available: true, text: "Ai Resume Insights: 1/week" },
                { title: "courses", available: false, text: "Ai‑Curated Courses" },
                { title: "allFreePlans", available: true, text: "+ All Free Plan Features" },
            ]
        },
        {
            duration: "Free",
            discount: 0,
            price: 0,
            currency: currency,
            popular: false,
            offer: false,
            // Keep features consistent with other plans; keep texts short and quota-aware
            features: [
                // Per Month additional features (added as unavailable here)
                { title: "interviewGuarantee", available: false, text: "Guaranteed Interviews" },
                { title: "reAccessSaved", available: false, text: "Resume Storage for Later Access" },
                { title: "insiderConnections", available: false, text: "Insider Connections" },
                { title: "sharableLink", available: false, text: "Sharable Link to Resume" },
                { title: "changeName", available: false, text: "Change CV Name" },
                { title: "downloadablePDF", available: false, text: "Download Resume as PDF" },
                { title: "severalTemplates", available: false, text: "Choose Your Template" },
                { title: "careerCoach", available: false, text: "24/7 Human Career Coach" },
                { title: "recruiterAccess", available: false, text: "Recruiter LinkedIn Access" },
                { title: "recommendation", available: true, text: "Starter • Try before upgrading" },
                { title: "createSeveral", available: true, text: "Create up to 2 resumes (Lifetime)" },
                { title: "coverLetter", available: true, text: "1 cover letter/day" },
                { title: "jobMatchInsights", available: true, text: "Job fetch: 1/day" },
                { title: "deepCompanyInsights", available: true, text: "Company insight: 1/week" },
                { title: "aiJobSuggestions", available: true, text: "Job Connections (maybe)" },
                { title: "autoApply", available: true, text: "Apply For Me 5/mo" },
                { title: "scheduleAutoApply", available: false, text: "Schedule Apply For Me" },
                { title: "interviewMockQuota", available: true, text: "Interview mock: 1/day" },
                { title: "followUpEmailQuota", available: true, text: "Follow-up email: 1/day" },
                { title: "aiInsights", available: true, text: "Resume insight: 1/week" },
                { title: "courses", available: false, text: "Ai‑Curated Courses" }
            ]
        }
    ]
}